import styled from 'styled-components';

export const BlackoutDateStyled = styled.div`
  .blackout-date-container {
    .Polaris-Tag {
      margin-right: 0.5rem;
      margin-top: 0.5rem;
    }
  }
`;
